import { render, staticRenderFns } from "./LoginTwo.vue?vue&type=template&id=bb76cd56&scoped=true&"
import script from "./LoginTwo.vue?vue&type=script&lang=js&"
export * from "./LoginTwo.vue?vue&type=script&lang=js&"
import style0 from "./LoginTwo.vue?vue&type=style&index=0&id=bb76cd56&prod&lang=less&scoped=true&"
import style1 from "./LoginTwo.vue?vue&type=style&index=1&id=bb76cd56&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb76cd56",
  null
  
)

export default component.exports